let showLoadingCallback: ((loading: boolean) => void) | undefined;

export default {
    show: () => {
        showLoadingCallback?.(true);
    },

    hide: () => {
        showLoadingCallback?.(false);
    },

    setShowLoadingCallback: (callback?: (text: boolean) => void) => {
        showLoadingCallback = callback;
    },
};
